const TAIL_CHARS_BEFORE_EXTENSION = 2;
const ELLIPSIS = '…';

/** Shortens a filename in the middle so its start and its extension stay readable: `quarterly-sal…es.xlsx`. */
export const truncateMiddle = (text: string, maxChars: number): string => {
  const characters = Array.from(text);
  if (characters.length <= maxChars) {
    return text;
  }
  const dotIndex = text.lastIndexOf('.');
  const extension = dotIndex > 0 ? Array.from(text.slice(dotIndex)) : [];
  const base = characters.slice(0, characters.length - extension.length);
  const tail = [...base.slice(-TAIL_CHARS_BEFORE_EXTENSION), ...extension];
  const headLength = Math.max(1, maxChars - tail.length - ELLIPSIS.length);

  return base.slice(0, headLength).join('') + ELLIPSIS + tail.join('');
};
